import { render } from "./ChatBubble.vue?vue&type=template&id=5e921482"
import script from "./ChatBubble.vue?vue&type=script&lang=js"
export * from "./ChatBubble.vue?vue&type=script&lang=js"

import "./ChatBubble.vue?vue&type=style&index=0&id=5e921482&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__